import axios from 'axios';

// POST /auth/resetPassword { username } — reuses the existing, proven reset flow (generates a
// hashToken and emails the reset link). username is the user's email (login key).
export async function resetPassword(email) {
  try {
    const res = await axios.post('/auth/resetPassword', { username: email });
    return { ok: res.data && res.data.status === 'SUCCESS' };
  } catch (error) {
    const data = error.response && error.response.data;
    return { ok: false, message: (data && data.status_message) || 'Failed to send reset email.' };
  }
}
